module.exports = __webpack_public_path__ + "static/media/noun_Camera_prohibited_1554484.f69ca6ff.svg";